import { ReactElement } from 'react';
import { Stack, DialogContentText, Alert, Link } from '@mui/material';
import { useFormikContext } from 'formik';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { CustomAutocomplete } from '~components/index';
import { hasError } from '~utils/formHelpers';
import { getBillingListLabelText } from '~utils/billingList';

import { useDialogAssingBillingListContext } from '../../DialogAssingBillingListContext';
import { FIELDS_NAME, initialValues } from '../../utils';

const DialogAssingBillingListSelection = (): ReactElement => {
  const { activeBillingLists } = useDialogAssingBillingListContext();
  const { isCarrier } = useTypePartnerCompany();

  const { errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<typeof initialValues>();

  return (
    <Stack spacing={2}>
      <DialogContentText variant="caption" color="text.secondary">
        Los pedidos que estén asociados a esta cuenta se tarifarán según la
        lista de precios seleccionada.
      </DialogContentText>

      <Stack spacing={2}>
        <CustomAutocomplete
          options={activeBillingLists}
          label="Seleccionar lista de precios"
          name={FIELDS_NAME.BILLING_LIST_ID}
          onChange={(_e, val) => {
            setFieldValue(
              FIELDS_NAME.BILLING_LIST_ID,
              val?.billingListId ?? '',
            );
          }}
          onBlur={() => {
            setFieldTouched(FIELDS_NAME.BILLING_LIST_ID, true);
          }}
          error={hasError(touched, errors, FIELDS_NAME.BILLING_LIST_ID)}
          getOptionLabel={getBillingListLabelText}
          renderOption={(props, option) => (
            <li {...props} style={{ display: 'flex' }}>
              {getBillingListLabelText(option)}
            </li>
          )}
        />

        <Alert
          severity="info"
          variant="standard"
          icon={false}
          sx={(currentTheme) => ({
            border: `1px solid ${currentTheme.palette.info.light}`,
            ...currentTheme.typography.caption,
          })}
        >
          Si no se encuentra una tarifa para un pedido, el mismo será tarifado
          en $ 0,00
        </Alert>
      </Stack>

      <DialogContentText
        variant="caption"
        // @NEW-GIVER-DASHBOARD: Hide until the help URL is available for Givers
        visibility={isCarrier ? 'visible' : 'hidden'}
      >
        Para mayor información sobre lista de precios, diríjase a este{' '}
        <Link
          href="https://routix.tawk.help/article/asignar-lista-de-precios"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          underline="hover"
          fontWeight="bold"
        >
          artículo
        </Link>
      </DialogContentText>
    </Stack>
  );
};

export default DialogAssingBillingListSelection;
